<template>
  <div class="relative w-full h-full flex flex-col z-100 bg-whiteOverride">
    <div
      v-if="!loaded"
      class="h-full w-full"
    >
      <AddFieldsHeader
        :envelope="envelope"
        :previewUrl="previewUrl"
        class="p-base"
      />
    </div>

    <VDocumentSetup
      v-else
      :fields="fields"
      :doc="envelope"
      class="pb-md"
    >
      <template v-slot:controls="slotProps">
        <AddFieldsHeader
          :envelope="envelope"
          :previewUrl="previewUrl"
          v-bind="slotProps"
        />
      </template>
    </VDocumentSetup>

    <div class="bg-whiteOverride p-base relative z-contextMenu md:z-auto">
      <div class="float-right md:mr-xxl flex gap-base">
        <BaseButton
          @click.native="back.action"
          variant="secondary"
          data-ec="envelopes_add_fields_page"
          data-et="back_button"
        >
          {{ $t('createEnvelope.addFields.back') }}
        </BaseButton>
        <BaseButton
          @click.native="next.action"
          data-ec="envelopes_add_fields_page"
          data-et="next_button"
        >
          {{ $t('createEnvelope.addFields.next') }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ts-check
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router/composables';
import { useActions, useGetters } from 'vuex-composition-helpers/dist';

import { useEnvelopesStepsNavigation } from '@/composables/envelopes';
import { useUserCurrentPreviewKey } from '@/composables/user';

import BaseButton from '@/components/library/buttons/BaseButton.vue';
import { AddFieldsHeader } from '@/components/ui/envelopeCreate/steps/addFields';
import VDocumentSetup from '@/views/components/DocumentSetup.vue';

const { getEnvelope } = useActions({
  getEnvelope: 'envelopes/GET_ENVELOPE',
});

const {
  envelope,
  fields,
} = useGetters({
  envelope: 'envelopes/updating',
  fields: 'envelopes/updatingFields',
});

const update = () => Promise.resolve({});

const isValid = computed(() => true);

const { back, next } = useEnvelopesStepsNavigation(update, isValid);

const route = useRoute();

const loaded = ref(false);

getEnvelope({ fingerprint: route.params.fingerprint, isUpdate: true })
  .then(() => {
    loaded.value = true;
  });

const signingPageUrl = process.env.VUE_APP_SIGNING_PAGE;
const { previewKey } = useUserCurrentPreviewKey();

const previewUrl = computed(() => {
  if (envelope.value.parties?.length && previewKey.value) {
    return `${signingPageUrl}/preview/${route.params.fingerprint}/${envelope.value.parties[0].status.fingerprint}#${previewKey.value?.preview_key}`;
  }

  return '';
});
</script>
